<template>
  <div class="app-container">
    <div class="filter-container">
      <div>
        <el-input style="width:200px;" v-model="listQuery.name" placeholder="名称" clearable />
      </div>
      <div>
        <el-input style="width:200px;" v-model="listQuery.phone" placeholder="电话" clearable />
      </div>
      <el-button type="primary" @click="handleFilter">搜索</el-button>
    </div>

    <el-table v-loading="listLoading" :data="list" element-loading-text="Loading" border fit highlight-current-row>
      <el-table-column align="center" label="ID" width="80" prop="id" />
      <el-table-column label="姓名" min-width="110" align="center" prop="name" />
      <el-table-column label="联系方式" min-width="110" align="center" prop="phone" />
      <el-table-column label="单位" min-width="200" align="center" prop="company" />
      <el-table-column label="备注" min-width="200" align="center" prop="remarks" />
      <el-table-column align="center" prop="created_at" label="创建时间" min-width="140" />
      <el-table-column label="操作" align="center" width="100" class-name="small-padding fixed-width">
        <template #default="{ row: { id } }">
          <el-button size="mini" type="danger" @click="handleDel(id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container">
      <el-pagination :current-page="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
        :total="total" background layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>


    <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
      width="60%">
      <el-form ref="form" :rules="rules" :model="form" label-position="left" label-width="70px"
        style="width: 88%; margin-left:50px;">
        <el-form-item label="标题" prop="title">
          <el-input v-model="form.title" />
        </el-form-item>

        <el-form-item label="详情" prop="content">
          <label>编辑文章</label>
          <tinymce ref="tinymce" style="width:100%;" :height="300" v-model="form.content" :value="form.content" />
        </el-form-item>


        <el-form-item label="权重" prop="sort">
          <el-input-number v-model="form.sort" :min="1" :max="9999"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取消</el-button>
        <el-button type="primary" @click="saveData" :loading="btnLoading">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import request from "@/utils/request";
import "babel-polyfill"; // es6 shim
import imgCropUpload from "vue-image-crop-upload";
import uploadList from "@/components/UploadList/index.vue";
import Tinymce from '@/components/Tinymce'
import { cooperation } from '@/api/basic.js'

export default {

  components: {
    "img-crop-upload": imgCropUpload, Tinymce,
    uploadList
  },
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        name: '',
        phone: ''
      },
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑",
        create: "添加"
      },
      form: {
        id: "",
        title: "",
        content: "",
        sort: "",
      },
      rules: {
        title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        content: [{ required: true, message: "标题不能为空", trigger: "blur" }]
      },
      btnLoading: false,
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      cooperation.list(this.listQuery).then(res => {
        this.list = res.data.data;
        this.total = res.data.total;
        this.listLoading = false;
      }).catch(err => {
        console.log('获取列表失败', err)
      })
    },

    handleFilter() {
      this.listQuery.page = 1
      this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    resetForm() {
      this.form = {
        id: "",
        title: "",
        content: "",
        sort: "",
      };
      this.btnLoading = false;
    },

    handleCreate() {
      this.resetForm()
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      if (this.$refs.tinymce) this.$refs.tinymce.setContent('')
      this.$nextTick(() => {
        this.$refs['form'].clearValidate() //清除校验结果
      })
    },
    handleUpdate(row) {
      this.resetForm();
      this.form = Object.assign({}, row); // copy obj
      this.form.type = Number(this.form.type)
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["form"].clearValidate();
      });
    },
    saveData() {
      console.log(this.form, this.form.imgArray);
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.btnLoading = true;
          request({
            url: "/api/backend/basics/article/add", // category_id:{1.首页轮播图}
            method: "post",
            data: this.form
          })
            .then(() => {
              this.dialogFormVisible = false;
              this.$notify({
                title: "成功",
                message: "保存成功",
                type: "success",
                duration: 2000
              });
              this.getList();
            })
            .finally(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    handleForbid(val, text) {
      this.$confirm("此操作将" + text + "该文章, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          request({
            url: "/api/backend/basics/article/state",
            method: "post",
            data: { id: val }
          }).then(() => {
            this.getList();
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
        })
        .catch(() => { });
    },

    handleDel(id) {
      this.$confirm("确定要删除, 是否继续?", "提示", {
        type: "warning"
      }).then(async () => {
        try {
          await cooperation.delete(id)
          this.$message({
            message: "删除成功",
            type: "success"
          })
          this.getList()
        } catch (err) {
          console.log('删除失败', err)
        }
      })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    },

  }
};
</script>

<style scoped>
.filter-container {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}

.filter-container>* {
  margin-left: 10px;
}

.upload-block {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 120px;
  height: 120px;
}

.uploaded-img {
  width: 120px;
  height: 120px;
}

.upload-block:hover {
  border-color: #409eff;
}

.uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.upload-one-component .upload-one-component-image {
  width: auto;
  height: 200px;
}

.flex {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
</style>
